import { render } from "./assinaturas.vue?vue&type=template&id=2c0549b4&scoped=true"
import script from "./assinaturas.vue?vue&type=script&lang=js"
export * from "./assinaturas.vue?vue&type=script&lang=js"

import "./assinaturas.vue?vue&type=style&index=0&id=2c0549b4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c0549b4"]])

export default __exports__